// ./src/contexts/TimelineItemsContext/TimelineItemsContext.tsx
//
// Thin context wrapper around the useTimelineItems hook. All derived data lives
// in the hook itself. See TasksContext / BudgetItemsContext for the pattern.

import React, { createContext, useContext } from "react";

import { useTimelineItems, UseTimelineItemsOptions, UseTimelineItemsReturn } from "@/hooks/useTimelineItems";

const TimelineItemsContext = createContext<UseTimelineItemsReturn | null>(null);

export interface TimelineItemsProviderProps extends UseTimelineItemsOptions {
  children: React.ReactNode;
}

export const TimelineItemsProvider: React.FC<TimelineItemsProviderProps> = ({ children, ...options }) => {
  const value = useTimelineItems(options);

  return <TimelineItemsContext.Provider value={value}>{children}</TimelineItemsContext.Provider>;
};

export const useTimelineItemsContext = (): UseTimelineItemsReturn => {
  const context = useContext(TimelineItemsContext);

  if (!context) {
    throw new Error(
      "useTimelineItemsContext must be used within a <TimelineItemsProvider>. " +
        "Wrap your component tree with <TimelineItemsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalTimelineItemsContext = (): UseTimelineItemsReturn | null => {
  return useContext(TimelineItemsContext);
};
